import {
    officePhoneFieldValues,
    fieldOfficePhoneContractBuyout,
    officePhoneTerminateContract,
    officePhoneInvoiceTLC,
    officePhoneBuyoutPolicy,
    officePhoneCustomerMontlyRate,
} from '../../utils/constant';

const {
    setup: {
        winback,
    },
    term: {
        threeYearTerm
    },
    twoMonthsDuration: {
        yes,
        no
    }
} = officePhoneFieldValues;

export const processContractBuyoutFields = (setupValue, termValue, contractBuyoutValue, lineFields) => {
    const buyoutChildFields = [
        officePhoneTerminateContract,
        officePhoneInvoiceTLC,
        officePhoneBuyoutPolicy,
        officePhoneCustomerMontlyRate];

    const hideBasedOnCondition = (field, isBuyout) => {
        const updatedField = { ...field };
        if (setupValue === winback && termValue === threeYearTerm) {
            if (!isBuyout && contractBuyoutValue === yes) {
                updatedField.fields.hidden = false;
            } else if (!isBuyout && contractBuyoutValue === no) {
                updatedField.fields.hidden = true;
            } else if (isBuyout) {
                updatedField.fields.hidden = false;
            }
        } else {
            updatedField.fields.hidden = true;
        }
        return updatedField;
    };

    return lineFields.map(lineField => {
        if (lineField.fields.name === fieldOfficePhoneContractBuyout) {
            return hideBasedOnCondition(lineField, true);
        }
        if (buyoutChildFields.includes(lineField.fields.name)) {
            return hideBasedOnCondition(lineField, false);
        }
        return lineField;
    });
};

export default {};